/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free data size converter. Convert between bytes, KB, MB, GB, TB and binary KiB, MiB, GiB, TiB. Runs in your browser.`)
};

const es_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de tamaño de datos gratuito. Convierte entre bytes, KB, MB, GB, TB y los binarios KiB, MiB, GiB, TiB. Se ejecuta en tu navegador.`)
};

const de_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Datengrößen-Konverter. Rechnen Sie zwischen Byte, KB, MB, GB, TB und den binären Einheiten KiB, MiB, GiB, TiB um. Läuft in Ihrem Browser.`)
};

const nl_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis omzetter voor gegevensgrootte. Converteer tussen bytes, KB, MB, GB, TB en binaire KiB, MiB, GiB, TiB. Draait in uw browser.`)
};

const fr_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de taille de données gratuit. Convertissez entre les octets, KB, MB, GB, TB et les unités binaires KiB, MiB, GiB, TiB. S'exécute dans votre navigateur.`)
};

const it_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di dimensioni dei dati gratuito. Converti tra B, KB, MB, GB, TB e i binari KiB, MiB, GiB, TiB. Funziona nel tuo browser.`)
};

const pt_br2_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de tamanho de dados gratuito. Converta entre bytes, KB, MB, GB, TB e os binários KiB, MiB, GiB, TiB. Funciona no seu navegador.`)
};

const pt_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor gratuito de tamanhos de dados. Converta entre bytes, KB, MB, GB, TB e os binários KiB, MiB, GiB, TiB. Executa no seu navegador.`)
};

const ja_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バイト、KB、MB、GB、TBおよびバイナリKiB、MiB、GiB、TiBの間を変換できる無料のデータサイズ変換ツール。ブラウザで実行されます。`)
};

const zh_ds_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费数据大小转换器。可在字节、KB、MB、GB、TB 以及二进制的 KiB、MiB、GiB、TiB 之间互相换算,在浏览器中直接运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ds_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ds_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ds_tool_description", locale)
	if (locale === "en") return en_ds_tool_description(inputs)
	if (locale === "es") return es_ds_tool_description(inputs)
	if (locale === "de") return de_ds_tool_description(inputs)
	if (locale === "nl") return nl_ds_tool_description(inputs)
	if (locale === "fr") return fr_ds_tool_description(inputs)
	if (locale === "it") return it_ds_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ds_tool_description(inputs)
	if (locale === "pt") return pt_ds_tool_description(inputs)
	if (locale === "ja") return ja_ds_tool_description(inputs)
	return zh_ds_tool_description(inputs)
};